export const ORDERING_CONFIGURATION = 'ordering-configuration';
export const ORDERING_TEST_SELECTIONS = 'ordering-test-selections';
export const ORDERING_PATIENT_STATUSES = 'ordering-patient-statuses';
export const ORDERING_PATIENT_TYPES = 'ordering-patient-types';
export const ORDERING_RELEVANT_CLINICAL_HISTORY = 'ordering-relevant-clinical-history';
export const ORDERING_DIAGNOSES = 'ordering-diagnoses';
